import React from "react";

import {
  // withTheme,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  CircularProgress,
  Button,
  Dialog
} from "@material-ui/core";
import { CreditCard, Close } from "@material-ui/icons";
// import Swipe from "react-easy-swipe";
import s from "./paymentmethods.module.css";
// import { theme } from "../../framework/theme";
import GlobalContext from "../../context/globalContext";
import config from "../../configuration/config";

import {
  Elements,
  injectStripe,
  StripeProvider,
  CardElement
} from "react-stripe-elements";

class PaymentMethods extends React.Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
    this.state = { addCardDialogState: false };
  }

  closeAddCardDialog() {
    this.setState({ addCardDialogState: false });
  }

  async componentWillMount() {
    await this.context.global.getUserByUuid();
  }

  render() {
    const { user } = this.context.global.data;

    return (
      <>
        <div>
          <AppBar className={s.appBar}>
            <Toolbar className={s.toolbar}>
              <div className={s.accountAppBarContentContainer}>
                <div className={s.accountAddressContainer}>
                  <Typography
                    component="h4"
                    variant="h5"
                    style={{ color: "white" }}
                  >
                    Payment Methods
                  </Typography>
                </div>
              </div>
              <div className={s.accountCloseButtonContainer}>
                <IconButton
                  color="inherit"
                  onClick={() => {
                    this.props.history.replace("/dashboard");
                  }}
                  aria-label="Close"
                  className={s.accountAppBar}
                >
                  <Close />
                </IconButton>
              </div>
            </Toolbar>
          </AppBar>
          <div style={{ height: 70 }} />
          <div className={s.content}>
            <div className={s.topBar}>
              <Button
                onClick={() => this.setState({ addCardDialogState: true })}
              >
                ADD NEW CARD
              </Button>
            </div>
            {(() => {
              if (!user) {
                return (
                  <div
                    style={{
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      padding: "3rem"
                    }}
                  >
                    <CircularProgress />
                  </div>
                );
              }
              return user.account.paymentOptions.map(pm => {
                return (
                  <div className={s.paymentOptionContainer}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <CreditCard />
                      <div style={{ color: "#555", paddingLeft: 20 }}>
                        {pm.type}{" "}
                        <span style={{ color: "#888", fontSize: 10 }}>
                          ending in
                        </span>{" "}
                        {pm.last4}
                      </div>
                    </div>
                  </div>
                );
              });
            })()}
          </div>
        </div>

        <Dialog
          open={this.state.addCardDialogState}
          onClose={this.closeAddCardDialog.bind(this)}
          scroll={"paper"}
        >
          <StripeProvider apiKey={config.stripe.key}>
            <div className={s.cardDialog}>
              <Elements>
                <InjectedCardForm
                  user={user}
                  createPaymentOption={this.context.global.createPaymentOption}
                  closeDialog={this.closeAddCardDialog.bind(this)}
                />
              </Elements>
            </div>
          </StripeProvider>
        </Dialog>
      </>
    );
  }
}

export class CardForm extends React.Component {
  state = {
    loading: false
  };
  handleSubmit = async ev => {
    // We don't want to let default form submission happen here, which would refresh the page.
    ev.preventDefault();

    // Within the context of `Elements`, this call to createToken knows which Element to
    // tokenize, since there's only one in this group.
    this.setState({ loading: true });
    let { token } = await this.props.stripe.createToken({
      name: this.props.user.name,
      email: this.props.user.email
    });

    try {
      await this.props.createPaymentOption(
        this.props.user.account.uuid,
        token.id
      );
      this.props.closeDialog();
      this.setState({ loading: false });
    } catch (err) {
      this.props.closeDialog();
      this.setState({ loading: false });
    }

    // However, this line of code will do the same thing:
    //
    // this.props.stripe.createToken({type: 'card', name: 'Jenny Rosen'});

    // You can also use createSource to create Sources. See our Sources
    // documentation for more: https://stripe.com/docs/stripe-js/reference#stripe-create-source
    //
    // this.props.stripe.createSource({type: 'card', owner: {
    //   name: 'Jenny Rosen'
    // }});
  };

  render() {
    return (
      <form className={s.cardForm} onSubmit={this.handleSubmit}>
        {this.state.loading ? (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%"
            }}
          >
            <CircularProgress />{" "}
          </div>
        ) : null}
        {/* <div className={s.newCardTop}>Enter Card Details</div> */}
        <div className={s.newCardMiddle}>
          <label>
            <CardElement style={{ base: { fontSize: "18px" } }} />
          </label>
        </div>
        <div className={s.newCardBottom}>
          <Button className={s.addCardButton} type="submit">
            Add Card
          </Button>
        </div>
      </form>
    );
  }
}

export const InjectedCardForm = injectStripe(CardForm);

export default PaymentMethods;
